import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import MerchantContent from "./MerchantContent";
import { merchantService } from '../../service/firebase/merchantService';
import type { Merchant } from '../../type';

const MerchantPage = () => {
  const queryClient = useQueryClient();

  // 상점 목록 조회
  const { data: merchants = [], isLoading, error } = useQuery({
    queryKey: ['merchants'],
    queryFn: () => merchantService.getAll(),
  });

  // 상점 추가
  const addMerchantMutation = useMutation({
    mutationFn: (merchant: Merchant) => merchantService.create(merchant),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['merchants'] });
    },
  });

  // 상점 수정
  const updateMerchantMutation = useMutation({
    mutationFn: (merchant: Merchant) => merchantService.update(merchant.merchant_id, merchant),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['merchants'] });
    },
  });

  // 상점 삭제
  const deleteMerchantMutation = useMutation({
    mutationFn: (merchant_id: string) => merchantService.delete(merchant_id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['merchants'] });
    },
  });

  const handleAddMerchant = async (merchant: Merchant) => {
    await addMerchantMutation.mutateAsync(merchant);
  };

  const handleUpdateMerchant = async (merchant: Merchant) => {
    await updateMerchantMutation.mutateAsync(merchant);
  };

  const handleDeleteMerchant = async (merchantId: string) => {
    await deleteMerchantMutation.mutateAsync(merchantId);
  };

  return (
    <MerchantContent
      merchants={merchants}
      loading={isLoading}
      error={error?.message || null}
      addMerchant={handleAddMerchant}
      updateMerchant={handleUpdateMerchant}
      deleteMerchant={handleDeleteMerchant}
    />
  );
};

export default MerchantPage;